import { format, parseISO } from "date-fns";

export type ComparisonMode = "none" | "wow" | "mom";

export interface ComparisonOption {
  value: ComparisonMode;
  label: string;
  fullLabel: string;
  days: number;
}

export const COMPARISON_OPTIONS: ComparisonOption[] = [
  { value: "none", label: "None", fullLabel: "None", days: 0 },
  { value: "wow", label: "Wk/Wk", fullLabel: "Week over Week", days: 7 },
  { value: "mom", label: "Mo/Mo", fullLabel: "Month over Month", days: 30 },
];

export function getComparisonDays(mode: ComparisonMode): number {
  return COMPARISON_OPTIONS.find((o) => o.value === mode)?.days ?? 0;
}

export function getComparisonPeriodLabel(mode: ComparisonMode): string {
  if (mode === "wow") return "Previous week";
  if (mode === "mom") return "Previous month";
  return "";
}

export const LOCATION_SERIES_COLORS = [
  "hsl(142, 71%, 45%)",
  "hsl(25, 95%, 53%)",
  "hsl(280, 65%, 60%)",
  "hsl(var(--chart-4))",
];

export const MAX_COMPARE_LOCATIONS = 4;

export function formatTrendDate(dateStr: string): string {
  try {
    return format(parseISO(dateStr), "M/d/yy");
  } catch {
    return dateStr;
  }
}
